<div class="flex max-w-[60rem] flex-col gap-2">
  @if (asins === undefined) {
    <app-spinner [display]="true"></app-spinner>
  } @else {
    <div class="flex h-[70vh] flex-col gap-2">
      <app-asin-selection class="min-h-0 flex-1" [customList]="asins" [readonly]="true" [csvExport]="true" />
    </div>
  }

  <div class="flex justify-end gap-2" *transloco="let t">
    <IButton label="{{ t('common.cancel') }}" color="gray" variant="ghost" (onClick)="close()" />
    <IButton label="{{ t('common.see_in_catalog') }}" (onClick)="openCatalog()" />
  </div>
</div>
